// react-transition-group@4.x calls findDOMNode from react-dom as a fallback when
// nodeRef is not provided. React 19 removed findDOMNode entirely. This shim re-exports
// react-dom in full and adds a stub so transitioning components don't crash.
// The stub returns the element directly if it already is a DOM node, otherwise null.
console.log('[react-dom-compat] shim loaded — findDOMNode stub active');
const ReactDOMOriginal = require('react-dom-original');

function findDOMNode(component) {
  if (component == null) return null;
  if (component.nodeType != null) return component;
  return null;
}

module.exports = Object.assign({}, ReactDOMOriginal, { findDOMNode });
